module.exports = __webpack_public_path__ + "img/g01.7f3d6288.jpg";